var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.error.key === "INVALID_CHECK_DIGIT"
    ? _c(
        "gs1-alert",
        [
          _c(
            "i18n",
            { attrs: { path: "invalid_check_digit.title", tag: "p" } },
            [
              _c(
                "a",
                {
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      _vm.suggest(_vm.error.suggestion)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.error.suggestion))]
              )
            ]
          )
        ],
        1
      )
    : _vm.error.key === "INVALID_INDICATOR_DIGIT"
    ? _c("gs1-alert", [
        _c("p", [_vm._v(_vm._s(_vm.$t("invalid_indicator_digit.title")))])
      ])
    : _vm.error.key === "NON_NUMERIC"
    ? _c(
        "gs1-alert",
        [
          _c("p", [_vm._v(_vm._s(_vm.$t("non_numeric.title")))]),
          _vm._v(" "),
          _c(
            "i18n",
            {
              staticClass: "small",
              attrs: { path: "too_short.message", tag: "p" }
            },
            [
              _c(
                "a",
                {
                  attrs: {
                    href: "https://www.gs1-germany.de/service/kontakt/",
                    target: "_blank",
                    rel: "noopener"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("contact_gs1")))]
              )
            ]
          )
        ],
        1
      )
    : _vm.error.key === "TOO_LONG"
    ? _c(
        "gs1-alert",
        [
          _c("p", [_vm._v(_vm._s(_vm.$t("too_long.title")))]),
          _vm._v(" "),
          _c(
            "i18n",
            {
              staticClass: "small",
              attrs: { path: "too_long.message", tag: "p" }
            },
            [
              _c(
                "a",
                {
                  attrs: {
                    href: "https://www.gs1-germany.de/service/kontakt/",
                    target: "_blank",
                    rel: "noopener"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("contact_gs1")))]
              )
            ]
          )
        ],
        1
      )
    : _vm.error.key === "TOO_SHORT"
    ? _c(
        "gs1-alert",
        [
          _c("p", [_vm._v(_vm._s(_vm.$t("too_short.title")))]),
          _vm._v(" "),
          _c(
            "i18n",
            {
              staticClass: "small",
              attrs: { path: "too_short.message", tag: "p" }
            },
            [
              _c(
                "a",
                {
                  attrs: {
                    href: "https://www.gs1-germany.de/service/kontakt/",
                    target: "_blank",
                    rel: "noopener"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("contact_gs1")))]
              )
            ]
          )
        ],
        1
      )
    : _c(
        "gs1-alert",
        [
          _c("p", [_vm._v(_vm._s(_vm.$t("unknown_error.title")))]),
          _vm._v(" "),
          _c(
            "i18n",
            {
              staticClass: "small",
              attrs: { path: "unknown_error.message", tag: "p" }
            },
            [_vm._v("\n    " + _vm._s(_vm.error.key) + "\n  ")]
          ),
          _vm._v(" "),
          _vm.error.technicalDetails
            ? [
                _c("p", { staticClass: "small text-muted" }, [
                  _vm._v(_vm._s(_vm.$t("technical_details")))
                ]),
                _vm._v(" "),
                _c("code", { staticClass: "small" }, [
                  _vm._v(
                    "\n      " + _vm._s(_vm.error.technicalDetails) + "\n    "
                  )
                ])
              ]
            : _vm._e()
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-225976f3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-225976f3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchFormAlerts.vue
// module id = null
// module chunks = 